module.exports = __webpack_public_path__ + "static/HF_TJSSC-7341d4a4c47aa4a9b6cfe1d12a9451fe.png";